
    import { defineComponent } from 'vue'
    import Dialog from 'primevue/dialog'
    import Dropdown from 'primevue/dropdown'
    import Message from 'primevue/message'
    import workspaceDataShareDialogDescriptor from './WorkspaceDataShareDialogDescriptor.json'

    export default defineComponent({
        name: 'workspace-repository-move-dialog',
        components: { Dialog, Dropdown, Message },
        props: { visible: { type: Boolean }, propDataset: { type: Object }, datasetCategories: { type: Array } },
        emits: ['close', 'share'],
        data() {
            return {
                workspaceDataShareDialogDescriptor,
                dataset: {} as any
            }
        },
        watch: {
            propDataset() {
                this.loadDataset()
            }
        },
        created() {
            this.loadDataset()
        },
        methods: {
            loadDataset() {
                if (this.propDataset) {
                    this.dataset = { ...this.propDataset }
                }
            },
            closeDialog() {
                this.loadDataset()
                this.$emit('close')
            },
            shareDataset(share: boolean) {
                if (!share) {
                    this.dataset.catTypeId = null
                }
                this.$emit('share', this.dataset)
            }
        }
    })
